import { Image } from 'expo-image';
import { StyleSheet, View } from 'react-native';

import { Button, IconInfo, Text, tokens } from '@fhs/ui';

import { StepsProgress } from '../steps-progress';

import { ChallengeHomeCardProps } from './types';

export function ChallengeHomeCardMobile(props: ChallengeHomeCardProps) {
  if (props.variant === 'secondary') {
    const { image, title, buttonText, onPress, onPressInfo } = props;
    return (
      <View style={[styles.container, { flexDirection: 'row' }]}>
        {image && <Image source={{ uri: image }} style={styles.image} />}
        <View style={styles.content}>
          <View style={[styles.header, { flex: 1 }]}>
            {title && (
              <Text.Heading numberOfLines={3} style={{ flex: 1 }} type="four">
                {title}
              </Text.Heading>
            )}
            <Button onPress={onPressInfo} type="ghost" style={[styles.info, { marginTop: -10.5 }]}>
              <Button.Icon>
                <IconInfo />
              </Button.Icon>
            </Button>
          </View>
          {buttonText && (
            <Button
              onPress={onPress}
              size="xs"
              style={[styles.button, { alignSelf: 'flex-start' }]}
            >
              <Button.Text>{buttonText}</Button.Text>
            </Button>
          )}
        </View>
      </View>
    );
  }

  const { badge, title, description, progress, buttonText, onPress, onPressInfo } = props;

  return (
    <View style={styles.container}>
      <View style={[styles.header, { alignItems: 'center' }]}>
        {badge && (
          <View style={styles.badge}>
            <Text.Ui size="sm" weight="semibold" style={{ color: tokens.colors.$white }}>
              {badge}
            </Text.Ui>
          </View>
        )}
        {title && (
          <Text.Heading numberOfLines={2} style={{ flex: 1 }} type="four">
            {title}
          </Text.Heading>
        )}
        <Button onPress={onPressInfo} type="ghost" style={styles.info}>
          <Button.Icon>
            <IconInfo />
          </Button.Icon>
        </Button>
      </View>
      {description && (
        <Text.Ui size="sm" style={{ marginTop: 8 }}>
          {description}
        </Text.Ui>
      )}
      {progress && (
        <StepsProgress
          style={{ marginTop: 12 }}
          currentStep={progress.current}
          totalSteps={progress.total}
        />
      )}
      {buttonText && (
        <Button onPress={onPress} size="xs" style={[styles.button, { alignSelf: 'flex-end' }]}>
          <Button.Text>{buttonText}</Button.Text>
        </Button>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    backgroundColor: tokens.colors.$white,
    padding: 16,
  },
  content: {
    marginLeft: 12,
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  badge: {
    backgroundColor: tokens.colors.$success,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
  },
  image: {
    width: 93,
    height: 93,
  },
  button: {
    marginTop: 12,
  },
  info: {
    margin: -8,
    alignSelf: 'flex-start',
  },
});
